import { Box } from "@mui/material";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

type MapLocation = {
  country: string;
  coordinates: [number, number];
};

const geoUrl = "https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson";

const WorldMapLocations = ({ countries = [] }: { countries?: MapLocation[] }) => {
  const transformedCountries = countries
    .filter((country) => country.coordinates !== undefined && country.coordinates.length === 2)
    .map((country) => ({
      ...country,
      coordinates: country.coordinates!.map(Number).reverse() as [number, number],
    }));

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "385px" },
        aspectRatio: "4 / 3",
      }}
    >
      <ComposableMap
        width={385}
        height={187}
        projectionConfig={{
          scale: 70,
        }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) => geographies.map((geo) => <Geography key={geo.rsmKey} geography={geo} fill="#CFCFCF" />)}
        </Geographies>
        {transformedCountries.map(({ country, coordinates }) => (
          <Marker key={country} coordinates={coordinates}>
            <circle cx={0} cy={0} r={14} fill="rgba(0, 128, 0, 0.3)" />
            <circle cx={0} cy={0} r={4} fill="#008000" />
          </Marker>
        ))}
      </ComposableMap>
    </Box>
  );
};

export default WorldMapLocations;
